import { createFileRoute } from "@tanstack/react-router";
import { PricingProgramsPage } from "../../../../views/programs/ProgramList";

export const Route = createFileRoute("/_authenticated/user/programs/")({
  component: PricingProgramsPage,
});
